import Box from '@eversports/klimt-primitives/legacy/Box'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useParams } from 'react-router-dom'

import { useMatchVisibilityBadgeMatchQuery } from '../../../../../graphql'
import { Localized } from '../../../../../localization/react'
import useLoggedInUserType from '../../../hooks/use-logged-in-user-type'
import { UserType } from '../../../Match.types'
import { visibilityTypeTranslation } from '../MatchVisibility.types'

const MatchVisibilityBadge = () => {
  const { id } = useParams<{ id: string }>()
  const { userType } = useLoggedInUserType()
  const { data } = useMatchVisibilityBadgeMatchQuery({ variables: { matchId: id } })

  if (!data || userType === UserType.ORGANIZER) return null

  return (
    <Box sx={{ backgroundColor: 'rgba(33, 166, 150, 0.08)', borderRadius: 1 }} px={[1, 4]} py={[1, 2]}>
      <Text variant="xsmall" sx={{ color: 'primary.main' }}>
        <Localized id={visibilityTypeTranslation[data.match.visibility]} />
      </Text>
    </Box>
  )
}

export default MatchVisibilityBadge
